import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import moment from 'moment';
import './styles/userBenefitDetail.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedUserBenefitDetail(props) {

  const values = queryString.parse(props.location.search);
  const benefitId = values.id;

  const { userId, token } = props;
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [benefit, setBenefit] = useState();
  const [applications, setApplications] = useState([]);
  const [chatId, setChatId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState();
  const [tab, setTab] = useState(0);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (selectedApplication) setShowModal(true);
  }, [selectedApplication]);

  const getData = async () => {
    setLoading(true);

    const benefitProm = await fetch(`${apiUrl}/benefits/detail/${benefitId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const benefitResp = await benefitProm.json();

    if (benefitResp.success) {
      const { benefit, applications, chatId } = benefitResp;

      setBenefit(benefit);
      setApplications(applications);
      setChatId(chatId);
    }

    setLoading(false);
  };

  const handleClose = () => {
    if (tab === 2) getData();

    setShowModal(false);
    setSelectedApplication();
    setTab(0);
  };

  const handleAssignBenefit = async () => {

    setCreating(true);

    const assignProm = await fetch(`${apiUrl}/benefits/assign`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        id: benefit._id,
        benefitApplicationId: selectedApplication._id
      })
    });

    const assignResp = await assignProm.json();

    if (assignResp.success) setTab(2);
    else alert('Ocurrió un error. Por favor inténtalo de nuevo');

    setCreating(false);
  };

  if (loading || !benefit) {
    return (
      <div className="user-benefit-detail-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  const benefitAssigned = benefit.status === 'ASSIGNED';

  return (
    <div className="user-benefit-detail-component">
      <Container>
        <Row>
          <Col>
            <i className="fas fa-arrow-alt-circle-left" style={{ fontSize: '1.3rem', marginBottom: '15px', cursor: 'pointer' }} onClick={() => props.history.push('/dashboard/seccion_solidaria')} />
            <h3>{benefit.name}</h3>
            <h5>
              <strong>
                Estado:{' '}
                {
                  benefit.status === 'PENDING' ? 'Pendiente' :
                  benefit.status === 'AVAILABLE' ? 'Disponible' :
                  benefit.status === 'DECLINED' ? 'Rechazada' :
                  'Asignada'
                }
              </strong>
            </h5>
            <h5>Ubicación: {benefit.location}</h5>
            <p>
              <strong>Descripción: </strong><br />
              {benefit.description}
            </p>
            <p>
              <strong>Detalles: </strong><br />
              {benefit.details}
            </p>
            <hr />
            <h4>
              {
                benefitAssigned ? 'Usuario beneficiado:' : 'Lista de aspirantes a esta ayuda'
              }
            </h4>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Fecha</th>
                  <th>
                    Prioridad{' '}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>
                          La prioridad se determina a través del score solidario. Esta puede ser baja, media o alta.
                        </Tooltip>
                      }
                    >
                      <i className="far fa-question-circle" />
                    </OverlayTrigger>
                  </th>
                  <th>Comentario</th>
                  <th style={{ textAlign: 'center' }}>Opciones</th>
                </tr>
              </thead>
              <tbody>
                {
                  (
                    benefitAssigned ?
                    applications.filter(item => item.status === 'APPROVED') :
                    applications
                  ).map((item, index) =>
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.userName}</td>
                      <td>{moment(item.dateCreated).format('YYYY-MM-DD')}</td>
                      <td>
                        {
                          item.priority === 'LOW' ? 'Baja' :
                          item.priority === 'MEDIUM' ? 'Media' : 'Alta'
                        }
                      </td>
                      <td>
                        {
                          !item.details ? '' :
                          (item.details.length > 60 ? `${item.details.substring(0, 60)}...` : item.details.substring(0, 60))
                        }
                      </td>
                      <td>
                        <div style={{ display: 'block', margin: '0 auto', width: 'fit-content' }}>
                          <Button
                          style={{ margin: '0 5px' }}
                            variant="info"
                            onClick={() => setSelectedApplication(item)}
                          >
                            Ver
                          </Button>
                          {
                            benefitAssigned &&
                            <Button
                              style={{ margin: '0 5px' }}
                              variant="info"
                              onClick={() => props.history.push(`/chat?id=${chatId}`)}
                            >
                              Ir al chat
                            </Button>
                          }
                        </div>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton></Modal.Header>
        {
          tab === 0 ?
          <>
            <Modal.Body>
              {
                selectedApplication &&
                <>
                  <p>
                    <strong>Nombre: </strong>{selectedApplication.userName}<br />
                    <strong>Fecha: </strong>{moment(selectedApplication.dateCreated).format('YYYY-MM-DD')}<br />
                    <strong>Prioridad: </strong>
                    {
                      selectedApplication.priority === 'LOW' ? 'Baja' :
                      selectedApplication.priority === 'MEDIUM' ? 'Media' : 'Alta'
                    }
                    {'  '}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>
                          La prioridad se determina a través del score solidario. Esta puede ser baja, media o alta.
                        </Tooltip>
                      }
                    >
                      <i className="far fa-question-circle" />
                    </OverlayTrigger>
                  </p>
                  <p>
                    <strong>Comentario: </strong><br />
                    {selectedApplication.details}
                  </p>
                  <strong>Información score solidario: </strong><br />
                  <ul>
                    <li>
                      <strong>Edad: </strong>
                      {selectedApplication.userScoreInfo.edad.label}
                    </li>
                    <li>
                      <strong>Personas a cargo: </strong>
                      {selectedApplication.userScoreInfo.personasACargo.label}
                    </li>
                    <li>
                      <strong>Hijos: </strong>
                      {selectedApplication.userScoreInfo.hijos.label}
                    </li>
                    {
                      selectedApplication.userScoreInfo.edadPromedioHijos &&
                      <li>
                        <strong>Edad promedio de los hijos: </strong>
                        {selectedApplication.userScoreInfo.edadPromedioHijos.label}
                      </li>
                    }
                    <li>
                      <strong>Tienen lo necesario para estudiar o trabajar: </strong>
                      {selectedApplication.userScoreInfo.necesarioEstudiarOTrabajar.label}
                    </li>
                    <li>
                      <strong>Al día con los servicios/arriendo: </strong>
                      {selectedApplication.userScoreInfo.alDiaServiciosArriendo.label}
                    </li>
                    <li>
                      <strong>Situación laboral: </strong>
                      {selectedApplication.userScoreInfo.situacionLaboral.label}
                    </li>
                    <li>
                      <strong>Cuántas personas tienen trabajo en el nucleo familiar: </strong>
                      {selectedApplication.userScoreInfo.nucleoFamiliarTrabajo.label}
                    </li>
                  </ul>
                </>
              }
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Regresar
              </Button>
              {
                !benefitAssigned &&
                <Button variant="info" onClick={() => setTab(1)}>
                  Asignar ayuda
                </Button>
              }
            </Modal.Footer>
          </> :
          tab === 1 ?
          <>
            <Modal.Body className="user-benefit-detail-modal">
              <h4 className="title">
                ¿Deseas confirmar la asignación de la ayuda {`"${benefit.name}"`}?
              </h4>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Regresar
              </Button>
              {
                !benefitAssigned &&
                <Button variant="info" onClick={handleAssignBenefit} disabled={creating}>
                  {
                    creating ? <Spinner variant="warning" animation="border" size="sm" /> : 'Confirmar'
                  }
                </Button>
              }
            </Modal.Footer>
          </> :
          <>
            <Modal.Body className="user-benefit-detail-modal">
              <h4 className="title">
                Se asignó esta ayuda correctamente. En el chat de la plataforma podrás comunicarte con el beneficiario de tu ayuda para concretar los detalles faltantes.
              </h4>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="info" onClick={handleClose}>
                Aceptar
              </Button>
            </Modal.Footer>
          </>
        }
      </Modal>
    </div>
  );
}

const UserBenefitDetail = connect(select)(ConnectedUserBenefitDetail);

export default withRouter(UserBenefitDetail);
